import { Seo } from '@/components/site/seo';
import { NewsSection } from '@/components/site/sections/news';
import { BannerHero } from '@/components/site/banner-hero';
import { listNews } from '@/lib/data/public';
import { useLiveData } from '~/hooks/useLiveData';
import { useLocaleContext } from '~/hooks/useLocaleContext';

export default function NewsListPage() {
  const { locale, dict } = useLocaleContext();
  const news = useLiveData(() => listNews(), [locale]).data ?? [];

  return (
    <>
      <Seo
        locale={locale}
        title={dict.news.title}
        description={dict.news.subtitle}
        path="/noticias"
        image="/banners/banner-web-6.jpg"
      />
      <BannerHero image="/banners/banner-web-6.jpg" title={dict.news.title} />
      <NewsSection locale={locale} dict={dict} news={news} compact />
    </>
  );
}
